"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlCurrencyFlag", function (currencyService) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      currencyCode: "="
    },
    template: '<span class="tl-currency-flag flag24 flag-{{flagCode}}"></span>',
    link: function link($scope, $el, $attrs) {
      var currencies = currencyService.getAll();
      var getFlagCode = function getFlagCode(currencyCode) {
        var currency = _.find(currencies, {
          isoCode: currencyCode
        });
        return currency != null && currency.flagCode;
      };
      $scope.$watch("currencyCode", function (currencyCode) {
        $scope.flagCode = getFlagCode(currencyCode);
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tl-currency-flag.js
// module id = 3017
// module chunks = 13